import axios from 'axios';

(function setCsrfHeaderFromCookie() {
    const raw = typeof document !== 'undefined' ? document.cookie : '';
    if (!raw) return;
    const parts = raw.split(';').map((s) => s.trim());
    for (const p of parts) {
        const eq = p.indexOf('=');
        if (eq <= 0) continue;
        const name = p.slice(0, eq);
        const val = decodeURIComponent(p.slice(eq + 1));
        if (name === 'XSRF-TOKEN' || name.indexOf('Antiforgery') >= 0 || name.indexOf('antiforgery') >= 0) {
            axios.defaults.headers.common['X-XSRF-TOKEN'] = val;
            axios.defaults.headers.common['X-CSRF-TOKEN'] = val;
            return;
        }
    }
})();

// البيانات حقيقية من الـ API (الخادم): عند تشغيل مشروع Management مع الـ Backend تُستدعى النهايات من نفس المصدر.
// إذا شغّلت الـ clientapp منفصلاً (npm run serve) فعطّل التعليق التالي وضَع عنوان الـ API:
// axios.defaults.baseURL = 'https://your-api-domain.com';

export default {




    //********************************************************************| Authintecations |***********************************************************

    login(bodyObjeect) {
        return axios.post(`/Security/login`, bodyObjeect);
    },

    IsLoggedin() {
        return axios.get(`/Security/IsLoggedin`);
    },

    Logout() {
        return axios.post(`/Security/Logout`);
    },

    ForgotPassword(bodyObject) {
        return axios.post(`/Security/forgot-password`, bodyObject);
    },

    ResetPassword(bodyObject) {
        return axios.post(`/Security/reset-password`, bodyObject);
    },









    // ********************************| Start Dictionaries |******************************


    // PaymentMethods
    GetPaymentMethods(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/PaymentMethods/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllPaymentMethods() {
        return axios.get(`api/admin/Dictionaries/PaymentMethods/GetAll`);
    },

    AddPaymentMethods(bodyObject) {
        return axios.post(`api/admin/Dictionaries/PaymentMethods/Add`, bodyObject);
    },

    EditPaymentMethods(bodyObject) {
        return axios.post(`api/admin/Dictionaries/PaymentMethods/Edit`, bodyObject);
    },

    DeletePaymentMethods(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/PaymentMethods/Delete`);
    },

    ChangeStatusPaymentMethods(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/PaymentMethods/ChangeStatus`);
    },







    // FinancialsWithdrawing
    GetFinancialsWithdrawing(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/FinancialsWithdrawing/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllFinancialsWithdrawing() {
        return axios.get(`api/admin/Dictionaries/FinancialsWithdrawing/GetAll`);
    },

    AddFinancialsWithdrawing(bodyObject) {
        return axios.post(`api/admin/Dictionaries/FinancialsWithdrawing/Add`, bodyObject);
    },

    EditFinancialsWithdrawing(bodyObject) {
        return axios.post(`api/admin/Dictionaries/FinancialsWithdrawing/Edit`, bodyObject);
    },

    DeleteFinancialsWithdrawing(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/FinancialsWithdrawing/Delete`);
    },

    ChangeStatusFinancialsWithdrawing(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/FinancialsWithdrawing/ChangeStatus`);
    },
















    // Subjects
    GetSubjects(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/Subjects/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllSubjects() {
        return axios.get(`api/admin/Dictionaries/Subjects/GetAll`);
    },

    AddSubjects(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Subjects/Add`, bodyObject);
    },

    EditSubjects(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Subjects/Edit`, bodyObject);
    },

    DeleteSubjects(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Subjects/Delete`);
    },

    ChangeStatusSubjects(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Subjects/ChangeStatus`);
    },





    // AcademicLevels
    GetAcademicLevels(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/AcademicLevels/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllAcademicLevels() {
        return axios.get(`api/admin/Dictionaries/AcademicLevels/GetAll`);
    },

    AddAcademicLevels(bodyObject) {
        return axios.post(`api/admin/Dictionaries/AcademicLevels/Add`, bodyObject);
    },

    EditAcademicLevels(bodyObject) {
        return axios.post(`api/admin/Dictionaries/AcademicLevels/Edit`, bodyObject);
    },

    DeleteAcademicLevels(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/AcademicLevels/Delete`);
    },

    ChangeStatusAcademicLevels(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/AcademicLevels/ChangeStatus`);
    },



    // Cities
    GetCities(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/Cities/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllCities() {
        return axios.get(`api/admin/Dictionaries/Cities/GetAll`);
    },

    AddCities(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Cities/Add`, bodyObject);
    },

    EditCities(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Cities/Edit`, bodyObject);
    },

    DeleteCities(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Cities/Delete`);
    },

    ChangeStatusCities(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Cities/ChangeStatus`);
    },


    // Municipalities
    GetMunicipalities(pageNo, pageSize, Search, CityId) {
        return axios.get(`api/admin/Dictionaries/Municipalities/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}&cityId=${CityId}`);
    },

    GetAllMunicipalities(CityId) {
        return axios.get(`api/admin/Dictionaries/Municipalities/GetAll?cityId=${CityId}`);
    },

    AddMunicipalities(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Municipalities/Add`, bodyObject);
    },

    EditMunicipalities(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Municipalities/Edit`, bodyObject);
    },

    DeleteMunicipalities(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Municipalities/Delete`);
    },

    ChangeStatusMunicipalities(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Municipalities/ChangeStatus`);
    },


    // Locations (Dictionaries – مناطق/مواقع)
    GetLocations(pageNo, pageSize, Search, MunicipalityId) {
        return axios.get(`api/admin/Dictionaries/Locations/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}&municipalityId=${MunicipalityId}`);
    },

    GetAllLocations(MunicipalityId) {
        return axios.get(`api/admin/Dictionaries/Locations/GetAll?municipalityId=${MunicipalityId}`);
    },

    AddLocations(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Locations/Add`, bodyObject);
    },

    EditLocations(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Locations/Edit`, bodyObject);
    },

    DeleteLocations(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Locations/Delete`);
    },

    ChangeStatusLocations(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Locations/ChangeStatus`);
    },


    // SubscriptionsTypes
    GetSubscriptionsTypes(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/SubscriptionsTypes/Get?pageNo=${pageNo}&pageSize=${pageSize}&search=${Search || ''}`);
    },

    GetAllSubscriptionsTypes() {
        return axios.get(`api/admin/Dictionaries/SubscriptionsTypes/GetAll`);
    },

    AddSubscriptionsTypes(bodyObject) {
        return axios.post(`api/admin/Dictionaries/SubscriptionsTypes/Add`, bodyObject);
    },

    EditSubscriptionsTypes(bodyObject) {
        return axios.post(`api/admin/Dictionaries/SubscriptionsTypes/Edit`, bodyObject);
    },

    DeleteSubscriptionsTypes(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/SubscriptionsTypes/Delete`);
    },

    ChangeStatusSubscriptionsTypes(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/SubscriptionsTypes/ChangeStatus`);
    },


    // NotificationsTypes
    GetNotificationsTypes(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/NotificationsTypes/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search || ''}`);
    },

    GetAllNotificationsTypes() {
        return axios.get(`api/admin/Dictionaries/NotificationsTypes/GetAll`);
    },

    AddNotificationsTypes(bodyObject) {
        return axios.post(`api/admin/Dictionaries/NotificationsTypes/Add`, bodyObject);
    },

    EditNotificationsTypes(bodyObject) {
        return axios.post(`api/admin/Dictionaries/NotificationsTypes/Edit`, bodyObject);
    },

    DeleteNotificationsTypes(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/NotificationsTypes/Delete`);
    },

    ChangeStatusNotificationsTypes(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/NotificationsTypes/ChangeStatus`);
    },


    // StudentsNotesTypes (student note categories used by the schools module).
    // Mirrors the conventional Dictionaries CRUD routes; if the backend route is
    // not yet present the page degrades to an empty state via its .catch handler.
    GetStudentsNotesTypes(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/StudentsNotesTypes/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search || ''}`);
    },

    AddStudentsNotesTypes(bodyObject) {
        return axios.post(`api/admin/Dictionaries/StudentsNotesTypes/Add`, bodyObject);
    },

    EditStudentsNotesTypes(bodyObject) {
        return axios.post(`api/admin/Dictionaries/StudentsNotesTypes/Edit`, bodyObject);
    },

    DeleteStudentsNotesTypes(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/StudentsNotesTypes/Delete`);
    },

    ChangeStatusStudentsNotesTypes(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/StudentsNotesTypes/ChangeStatus`);
    },


    // Trip Categories (dashboard management: icon + pricing).
    // GetTripCategories already exists below; only the write ops are new.
    AddTripCategories(bodyObject) {
        return axios.post(`api/admin/Trips/Categories/Add`, bodyObject);
    },
    EditTripCategories(bodyObject) {
        return axios.post(`api/admin/Trips/Categories/Edit`, bodyObject);
    },
    ChangeStatusTripCategories(Id) {
        return axios.post(`api/admin/Trips/${Id}/Categories/ChangeStatus`);
    },

    // VehiclesTypes
    GetVehiclesTypes(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/VehicleTypes/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllVehiclesTypes() {
        return axios.get(`api/admin/Dictionaries/VehicleTypes/GetAll`);
    },

    AddVehiclesTypes(bodyObject) {
        return axios.post(`api/admin/Dictionaries/VehicleTypes/Add`, bodyObject);
    },

    EditVehiclesTypes(bodyObject) {
        return axios.post(`api/admin/Dictionaries/VehicleTypes/Edit`, bodyObject);
    },

    DeleteVehiclesTypes(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/VehicleTypes/Delete`);
    },

    ChangeStatusVehiclesTypes(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/VehicleTypes/ChangeStatus`);
    },





    // AcademicSpecializations
    GetAcademicSpecializations(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/AcademicSpecializations/Get?pageno=${pageNo}&pagesize=${pageSize}
        &Search=${Search}`);
    },

    GetAllAcademicSpecializations(Id) {
        return axios.get(`api/admin/Dictionaries/AcademicSpecializations/GetAll?AcademicLevelId=${Id}`);
    },

    // Paged list of child (leaf/sub) academic specializations used by the
    // AcademicSpecializations management screen. Mirrors the sibling Get route.
    GetAcademicSpecializationsChild(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/AcademicSpecializations/GetChild?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search || ''}`);
    },

    // Full parent path (root -> ... -> node) used to pre-fill the cascading
    // selects when editing a specialization.
    GetAcademicSpecializationPath(Id) {
        return axios.get(`api/admin/Dictionaries/AcademicSpecializations/Path?id=${Id}`);
    },

    AddAcademicSpecializations(bodyObject) {
        return axios.post(`api/admin/Dictionaries/AcademicSpecializations/Add`, bodyObject);
    },

    EditAcademicSpecializations(bodyObject) {
        return axios.post(`api/admin/Dictionaries/AcademicSpecializations/Edit`, bodyObject);
    },

    DeleteAcademicSpecializations(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/AcademicSpecializations/Delete`);
    },

    ChangeStatusAcademicSpecializations(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/AcademicSpecializations/ChangeStatus`);
    },
    // Vehicles
    GetVehicles(pageNo, pageSize, Search, driverId, schoolId) {
        let url = `api/admin/Vehicles/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}&driverId=${driverId || ''}`;
        if (schoolId) url += `&schoolId=${schoolId}`;
        return axios.get(url);
    },

    GetVehiclesSuspended(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Vehicles/GetSuspended?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },






    // Faq
    GetFaq(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/Faq/Get?pageno=${pageNo}&pagesize=${pageSize}
        &Search=${Search}`);
    },

    DeleteFaq(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Faq/Delete`);
    },

    ChangeStatusFaq(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Faq/ChangeStatus`);
    },


    // Notifications (Users)
    // Web P0 FIX: the inbox now lists the SIGNED-IN admin/school-admin's own
    // notifications via the new AdminNotificationsController endpoint (the old
    // Dictionaries/Notifications/Get is a super-admin-only system-wide view).
    GetNotifications(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Notifications/Inbox?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    // View one of the caller's own notifications.
    GetNotificationDetail(Id) {
        return axios.get(`api/admin/Notifications/${Id}`);
    },

    // Mark one of the caller's own notifications as read.
    MarkNotificationRead(Id) {
        return axios.post(`api/admin/Notifications/${Id}/MarkRead`);
    },

    AddNotifications(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Notifications/Push`, bodyObject);
    },

    PushNotifications(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Notifications/Push`, bodyObject);
    },


    GetDashboardInfo() {
        return axios.get(`api/admin/Dictionaries/Dashboard/Get`);
    },

    // Dashboard - Overview Page
    GetDashboardOverview() {
        return axios.get('api/admin/Dictionaries/Dashboard/Overview');
    },

    // Dashboard - Events Page
    GetDashboardEvents() {
        return axios.get('api/admin/Dictionaries/Dashboard/Events');
    },

    // Dashboard - Statistics Page
    GetDashboardStatistics() {
        return axios.get('api/admin/Dictionaries/Dashboard/Statistics');
    },

    // Dashboard - Events: Top Cities by Month
    GetDashboardTopCities(month) {
        return axios.get(`api/admin/Dictionaries/Dashboard/TopCities?month=${month}`);
    },



    // ********************************| End Dictionaries |********************************
























    // ********************************| Courses |************************************

    GetCourses(pageNo, pageSize, Search, IsFree, IsDiscount, SalesStatus, ViewStatus) {
        return axios.get(`api/admin/Courses/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}
            &IsFree=${IsFree}&IsDiscount=${IsDiscount}&SalesStatus=${SalesStatus}&Status=${ViewStatus}`);
    },

    GetAllCourses() {
        return axios.get(`api/admin/Courses/GetAll`);
    },

    GetAllCoursesName() {
        return axios.get(`api/admin/Courses/GetNames`);
    },

    GetAllCoursesBySubjectSpecialization(SubjectId, AcademicSpecializationId) {
        return axios.get(`api/admin/Courses/GetBySubjectSpecialization?SubjectId=${SubjectId}&AcademicSpecializationId=${AcademicSpecializationId}`);
    },

    AddCourses(bodyObject) {
        return axios.post(`api/admin/Courses/Add`, bodyObject);
    },

    EditCourses(bodyObject) {
        return axios.post(`api/admin/Courses/Edit`, bodyObject);
    },

    DeleteCourses(Id) {
        return axios.post(`api/admin/Courses/${Id}/Delete`);
    },

    ChangeStatusCourses(Id) {
        return axios.post(`api/admin/Courses/${Id}/ChangeStatus`);
    },

    ChangeSalesStatusCourses(Id) {
        return axios.post(`api/admin/Courses/${Id}/ChangeSalesStatus`);
    },

    CloseCourses(Id) {
        return axios.post(`api/admin/Courses/${Id}/Close`);
    },

    AddTransferCoursesCourses(bodyObject) {
        return axios.post(`api/admin/Courses/TransferCourses`, bodyObject);
    },




    //Closed Course
    GetClosedCourses(pageNo, pageSize, Search, IsFree, IsDiscount) {
        return axios.get(`api/admin/Courses/GetClosed?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}
            &IsFree=${IsFree}&IsDiscount=${IsDiscount}`);
    },

    OpenCourses(Id) {
        return axios.post(`api/admin/Courses/${Id}/Open`);
    },


    //ChartInfo
    GetAllCoursesChartInfo() {
        return axios.get(`api/admin/Courses/Chart/GetAll`);
    },


    //ChartInfo
    GetCoursesChartInfo(Id) {
        return axios.get(`api/admin/Courses/Chart/Get?Id=${Id}`);
    },








    //Shapters
    GetCourseShapters(Id, Search) {
        return axios.get(`api/admin/Courses/Shapters/Get?Id=${Id}&Search=${Search}`);
    },

    GetAllShapters(Id) {
        return axios.get(`api/admin/Courses/Shapters/GetAll?CourseId=${Id}`);
    },

    AddShapters(bodyObject) {
        return axios.post(`api/admin/Courses/Shapters/Add`, bodyObject);
    },

    EditShapters(bodyObject) {
        return axios.post(`api/admin/Courses/Shapters/Edit`, bodyObject);
    },

    DeleteShapters(Id) {
        return axios.post(`api/admin/Courses/${Id}/Shapters/Delete`);
    },

    ChangeStatusShapters(Id) {
        return axios.post(`api/admin/Courses/${Id}/Shapters/ChangeStatus`);
    },





    SuspendDriver(bodyObject) {
        return axios.post(`api/admin/Drivers/Suspend`, bodyObject);
    },

    //Lectures
    GetCourseLectures(CourseId, ShapterId, Search) {
        return axios.get(`api/admin/Courses/Lectures/Get?CourseId=${CourseId}&ShapterId=${ShapterId}&Search=${Search}`);
    },

    AddLectures(bodyObject) {
        return axios.post(`api/admin/Courses/Lectures/Add`, bodyObject);
    },

    EditLectures(bodyObject) {
        return axios.post(`api/admin/Courses/Lectures/Edit`, bodyObject);
    },

    DeleteLectures(Id) {
        return axios.post(`api/admin/Courses/${Id}/Lectures/Delete`);
    },

    ChangeStatusLectures(Id) {
        return axios.post(`api/admin/Courses/${Id}/Lectures/ChangeStatus`);
    },






    //LecturesAttashments
    GetCourseLecturesAttashments(LectureId, Search) {
        return axios.get(`api/admin/Courses/LecturesAttashments/Get?LectureId=${LectureId}&Search=${Search}`);
    },

    AddLecturesAttashments(bodyObject) {
        return axios.post(`api/admin/Courses/LecturesAttashments/Add`, bodyObject);
    },

    EditLecturesAttashments(bodyObject) {
        return axios.post(`api/admin/Courses/LecturesAttashments/Edit`, bodyObject);
    },

    DeleteLecturesAttashments(Id) {
        return axios.post(`api/admin/Courses/${Id}/LecturesAttashments/Delete`);
    },

    ChangeStatusLecturesAttashments(Id) {
        return axios.post(`api/admin/Courses/${Id}/LecturesAttashments/ChangeStatus`);
    },


    //LecturesAttashments Vdocipher

    AddLecturesVdocipher(bodyObject) {
        return axios.post(`api/admin/Courses/LecturesAttashments/Vdocipher/Add`, bodyObject);
    },

    EditLecturesVdocipher(bodyObject) {
        return axios.post(`api/admin/Courses/LecturesAttashments/Vdocipher/Edit`, bodyObject);
    },

    GetCourseLecturesAttashmentsShowVideo(Id) {
        return axios.get(`api/admin/Courses/LecturesAttashments/Vdocipher/ShowVideo?Id=${Id}`);
    },







    //Exams
    GetCourseExams(CourseId, ShapterId, Search) {
        return axios.get(`api/admin/Courses/Exams/Get?CourseId=${CourseId}&ShapterId=${ShapterId}&Search=${Search}`);
    },

    AddExams(bodyObject) {
        return axios.post(`api/admin/Courses/Exams/Add`, bodyObject);
    },

    EditExams(bodyObject) {
        return axios.post(`api/admin/Courses/Exams/Edit`, bodyObject);
    },

    DeleteExams(Id) {
        return axios.post(`api/admin/Courses/${Id}/Exams/Delete`);
    },

    ChangeStatusExams(Id) {
        return axios.post(`api/admin/Courses/${Id}/Exams/ChangeStatus`);
    },






    //ExamsQuestions
    GetCourseExamsQuestions(ExamId, Search) {
        return axios.get(`api/admin/Courses/ExamsQuestions/Get?ExamId=${ExamId}&Search=${Search}`);
    },

    AddExamsQuestions(bodyObject) {
        return axios.post(`api/admin/Courses/ExamsQuestions/Add`, bodyObject);
    },

    EditExamsQuestions(bodyObject) {
        return axios.post(`api/admin/Courses/ExamsQuestions/Edit`, bodyObject);
    },

    DeleteExamsQuestions(Id) {
        return axios.post(`api/admin/Courses/${Id}/ExamsQuestions/Delete`);
    },

    ChangeStatusExamsQuestions(Id) {
        return axios.post(`api/admin/Courses/${Id}/ExamsQuestions/ChangeStatus`);
    },


    //Students
    GetCourseStudents(Id, Search) {
        return axios.get(`api/admin/Courses/Students/Get?Id=${Id}&Search=${Search}`);
    },


    //Review
    GetCourseReview(Id, Search) {
        return axios.get(`api/admin/Courses/Review/Get?Id=${Id}&Search=${Search}`);
    },





    //// ********************************| End Courses |********************************















    //// ********************************| Students |********************************


    GetStudents(pageNo, pageSize, Search, schoolsId, status) {
        return axios.get(`api/admin/Students/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}&schoolsId=${schoolsId || ''}&status=${status || ''}`);
    },

    GetAllStudents() {
        return axios.get(`api/admin/Students/GetAll`);
    },

    AddStudents(bodyObject) {
        return axios.post(`api/admin/Students/Add`, bodyObject);
    },

    EditStudents(bodyObject) {
        return axios.post(`api/admin/Students/Edit`, bodyObject);
    },

    ChangeStatusStudents(Id) {
        return axios.post(`api/admin/Students/${Id}/ChangeStatus`);
    },

    ResetDeviceStudents(Id) {
        return axios.post(`api/admin/Students/${Id}/ResetDevice`);
    },

    ResetPasswordStudents(Id) {
        return axios.post(`api/admin/Students/${Id}/ResetPassword`);
    },

    DeleteStudents(Id) {
        return axios.post(`api/admin/Students/Delete/${Id}`);
    },
    SuspendStudent(bodyObject) {
        return axios.post(`api/admin/Students/Suspend`, bodyObject);
    },
    CancelSuspend(Id) {
        return axios.post(`api/admin/Students/${Id}/CancelSuspend`);
    },
    //Suspends
    SuspendsStudents(bodyObject) {
        return axios.post(`api/admin/Students/Suspends/Add`, bodyObject);
    },

    GetSuspendsStudents(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Students/Suspends/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    CanselSuspends(Id) {
        return axios.post(`api/admin/Students/${Id}/Suspends/Cansel`);
    },





    //ChangeRequest
    GetChangeRequest(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Students/ChangeRequest/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    AcceptChangeRequest(Id) {
        return axios.post(`api/admin/Students/${Id}/ChangeRequest/Accept`);
    },

    AcceptAllChangeRequest() {
        return axios.post(`api/admin/Students/ChangeRequest/AcceptAll`);
    },

    RejectChangeRequest(Id) {
        return axios.post(`api/admin/Students/${Id}/ChangeRequest/Reject`);
    },

    DeleteChangeRequest(Id) {
        return axios.post(`api/admin/Students/${Id}/ChangeRequest/Delete`);
    },

    DeleteAllChangeRequest() {
        return axios.post(`api/admin/Students/ChangeRequest/DeleteAll`);
    },





    //CoursesRequests
    GetCoursesRequests(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Students/CoursesRequests/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    AcceptCoursesRequests(Id) {
        return axios.post(`api/admin/Students/${Id}/CoursesRequests/Accept`);
    },

    RejectCoursesRequests(Id) {
        return axios.post(`api/admin/Students/${Id}/CoursesRequests/Reject`);
    },

    DeleteCoursesRequests(Id) {
        return axios.post(`api/admin/Students/${Id}/CoursesRequests/Delete`);
    },









    //Studetns Courses
    GetStudentsCourses(Id, Search) {
        return axios.get(`api/admin/Students/Courses/Get?Id=${Id}&Search=${Search}`);
    },

    AddStudentsCourses(bodyObject) {
        return axios.post(`api/admin/Students/Courses/Add`, bodyObject);
    },

    AddStudentsCoursesValue(bodyObject) {
        return axios.post(`api/admin/Students/Courses/AddValue`, bodyObject);
    },

    DropStudentsCourses(bodyObject) {
        return axios.post(`api/admin/Students/Courses/Drop`, bodyObject);
    },







    //Wallet
    GetStudentsWallet(Id) {
        return axios.get(`api/admin/Students/Wallet/Get?Id=${Id}`);
    },

    AddStudentsWalletValue(bodyObject) {
        return axios.post(`api/admin/Students/Wallet/Charge`, bodyObject);
    },






    //Devices
    GetStudentsDevices(Id) {
        return axios.get(`api/admin/Students/Devices/Get?Id=${Id}`);
    },


    GetAllStudentsChartInfo() {
        return axios.get(`api/admin/Students/Chart/GetAll`);
    },



    //// ********************************| End Of Students |********************************




    //// ********************************| Parents |********************************

    GetParents(pageNo, pageSize, Search, schoolsId, status) {
        return axios.get(`api/admin/Parents/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}&schoolsId=${schoolsId || ''}&status=${status || ''}`);
    },

    GetAllParents() {
        return axios.get(`api/admin/Parents/GetAll`);
    },

    SearchParentByPhone(phone) {
        return axios.get(`api/admin/Parents/SearchByPhone?phone=${encodeURIComponent(phone || '')}`);
    },

    AddParents(bodyObject) {
        return axios.post(`api/admin/Parents/Add`, bodyObject);
    },

    EditParents(bodyObject) {
        return axios.post(`api/admin/Parents/Edit`, bodyObject);
    },

    DeleteParents(Id) {
        return axios.post(`api/admin/Parents/Delete/${Id}`);
    },

    SuspendParent(bodyObject) {
        return axios.post(`api/admin/Parents/Suspend`, bodyObject);
    },

    CancelSuspendParent(Id) {
        return axios.post(`api/admin/Parents/CancelSuspend/${Id}`);
    },

    AddParentChildren(bodyObject) {
        return axios.post(`api/admin/Parents/AddChildren`, bodyObject);
    },

    // STU-001: view a parent's linked children (the {id} is the parent's User id,
    // since the endpoint joins PassengersParents.ParentsId == User.Id).
    GetParentChildren(Id) {
        return axios.get(`api/admin/Parents/${Id}/Children`);
    },

    GetStudentsForParent(pageNo, pageSize, Search, schoolsId) {
        return axios.get(`api/admin/Students/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search || ''}&schoolsId=${schoolsId || ''}`);
    },

    //// ********************************| End Of Parents |********************************




    //// ********************************| SchoolTrips |********************************

    GetSchoolTrip(pageNo, pageSize, Search, schoolId, driversId) {
        return axios.get(`api/admin/SchoolTrips/GetRoutes?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search || ''}&schoolId=${schoolId || ''}&driversId=${driversId || ''}`);
    },

    GetSchoolTripsStatistics() {
        return axios.get(`api/admin/SchoolTrips/Statistics`);
    },

    GetSchoolTripsStudentsList(pageNo, pageSize, Search, schoolsId) {
        return axios.get(`api/admin/SchoolTrips/GetStudentsList?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search || ''}&schoolsId=${schoolsId || ''}`);
    },

    CreateSchoolTrip(bodyObject) {
        console.log(bodyObject);
        return axios.post(`api/admin/SchoolTrips/Create`, bodyObject);
    },

    EditSchoolTrip(bodyObject) {
        return axios.post(`api/admin/SchoolTrips/Edit`, bodyObject);
    },

    DeleteSchoolTrip(Id) {
        return axios.post(`api/admin/SchoolTrips/Delete/${Id}`);
    },

    GetSchoolTripById(Id) {
        return axios.get(`api/admin/SchoolTrips/${Id}`);
    },

    GetSchoolTripStudents(Id) {
        return axios.get(`api/admin/SchoolTrips/GetStudents/${Id}`);
    },

    ChangeSchoolTripDriver(bodyObject) {
        return axios.post(`api/admin/SchoolTrips/ChangeDriver`, bodyObject);
    },

    // ترتيب نقاط التقاط الطلاب على المسار (يحدده مسؤول المدرسة فيتبعه تطبيق السائق حرفياً).
    // body: { AssignmentId, Stops: [{ PassengerId, StopOrder, PickupLat?, PickupLng? }] }
    SetSchoolRouteOrder(bodyObject) {
        return axios.post(`api/admin/SchoolTrips/SetRouteOrder`, bodyObject);
    },

    SwapRouteGroup(fromRouteId, targetDriverId) {
        return axios.post(`api/admin/SchoolTrips/SwapGroup`, { fromRouteId, targetDriverId });
    },

    GetTodaySchoolTrips() {
        return axios.get(`api/admin/SchoolTrips/TodayTrips`);
    },

    GetWaitingSchoolTrips() {
        return axios.get(`api/admin/SchoolTrips/WaitingTrips`);
    },

    GetTripDetails(tripId) {
        return axios.get(`api/admin/SchoolTrips/TripDetails/${tripId}`);
    },

    AddStudentToRoute(routeId, studentId) {
        return axios.post(`api/admin/SchoolTrips/AddStudent/${routeId}/${studentId}`);
    },

    RemoveStudentFromRoute(routeId, studentId) {
        return axios.post(`api/admin/SchoolTrips/RemoveStudent/${routeId}/${studentId}`);
    },

    // Task 26: dashboard live in-progress board (auto-refreshed client-side every 15s).
    GetLiveBoard() {
        return axios.get(`api/admin/SchoolTrips/LiveBoard`);
    },

    // Audit P1 #9: admin school-trip lifecycle control (mirrors the driver app,
    // gated to admin/school-admin server-side).
    StartSchoolTrip(tripId) {
        return axios.post(`api/admin/SchoolTrips/StartTrip/${tripId}`);
    },
    CompleteSchoolTrip(tripId) {
        return axios.post(`api/admin/SchoolTrips/CompleteTrip/${tripId}`);
    },
    SchoolTripBusArrived(tripId, passengerId) {
        return axios.post(`api/admin/SchoolTrips/BusArrived/${tripId}/${passengerId}`);
    },

    //// ********************************| End Of SchoolTrips |********************************













    // ********************************| Instructors |********************************



    GetInstructors(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Instructors/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllInstructors() {
        return axios.get(`api/admin/Instructors/GetAll`);
    },

    AddInstructors(bodyObject) {
        return axios.post(`api/admin/Instructors/Add`, bodyObject);
    },

    EditInstructors(bodyObject) {
        return axios.post(`api/admin/Instructors/Edit`, bodyObject);
    },

    ChangeStatusInstructors(Id) {
        return axios.post(`api/admin/Instructors/${Id}/ChangeStatus`);
    },

    ResetDeviceInstructors(Id) {
        return axios.post(`api/admin/Instructors/${Id}/ResetDevice`);
    },

    ResetPasswordInstructors(Id) {
        return axios.post(`api/admin/Instructors/${Id}/ResetPassword`);
    },

    DeleteInstructors(Id) {
        return axios.post(`api/admin/Instructors/${Id}/Delete`);
    },

    //Financials
    PayInstructorsFinancials(bodyObject) {
        return axios.post(`api/admin/Instructors/Financials/Pay`, bodyObject);
    },

    GetInstructorsFinancials(Id) {
        return axios.get(`api/admin/Instructors/Financials/Get?Id=${Id}`);
    },

    DeleteInstructorsFinancials(Id) {
        return axios.post(`api/admin/Instructors/${Id}/Financials/Delete`);
    },




    //Suspends
    SuspendsInstructors(bodyObject) {
        return axios.post(`api/admin/Instructors/Suspends/Add`, bodyObject);
    },

    GetSuspendsInstructors(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Instructors/Suspends/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    CanselInstructors(Id) {
        return axios.post(`api/admin/Instructors/${Id}/Suspends/Cansel`);
    },



    // ********************************| End Of Instructors |********************************












    // ********************************| Financial |********************************

    GetSubscriptions(pageNo, pageSize, Search, From, To) {
        return axios.get(`api/admin/Financial/GetSubscriptions?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}
        &From=${From}&To=${To}`);
    },

    GetRecharge(pageNo, pageSize, Search, From, To, UserId, DistributorsId, PaymentMethodId) {
        return axios.get(`api/admin/Financial/GetRecharge?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}
        &From=${From}&To=${To}&UserId=${UserId}&DistributorsId=${DistributorsId}&PaymentMethodId=${PaymentMethodId}`);
    },

    GetWalletTracker(pageNo, pageSize, Search, From, To, ProcessType, Channel) {
        return axios.get(`api/admin/Financial/GetWalletTracker?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}
        &From=${From}&To=${To}&ProcessType=${ProcessType}&Channel=${Channel}`);
    },


    GetWithdrawingTracker(pageNo, pageSize, Search, From, To, PaymentMethodId, WithdrawingId, Operation) {
        return axios.get(`api/admin/Financial/GetWithdrawingTracker?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}
        &From=${From}&To=${To}&PaymentMethodId=${PaymentMethodId}&WithdrawingId=${WithdrawingId}&Operation=${Operation}`);
    },
    GetWalletPurchases(pageNo, pageSize, Search, From, To, WalletId, UserId, IsSubscription) {
        return axios.get(`api/admin/Financial/GetWalletPurchases?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}
  &From=${From}&To=${To}&WalletId=${WalletId}&UserId=${UserId}&IsSubscription=${IsSubscription}`);
    },

    // P0-4 (audit 2026-05-26) — manual financial-transaction Add/Edit (super-admin).
    AddFinancial(bodyObject) {
        return axios.post(`api/admin/Financial/Add`, bodyObject);
    },

    EditFinancial(bodyObject) {
        return axios.post(`api/admin/Financial/Edit`, bodyObject);
    },





    // ********************************| End Of Financial |********************************














    // ********************************| VoucherCards |********************************

    GetVoucherCards(pageNo, pageSize, Search, DistributorsId) {
        return axios.get(`api/admin/VoucherCards/Get?pageNo=${pageNo}&pagesize=${pageSize}&Search=${Search}&DistributorsId=${DistributorsId}`);
    },

    AddVoucherCards(bodyObject) {
        return axios.post('api/admin/VoucherCards/Add', bodyObject);
    },

    SaleVoucherCards(Id) {
        // responseType MUST be axios config (3rd arg), not the POST body — the
        // Sale endpoint streams the generated cards file back as a blob.
        return axios.post(`api/admin/VoucherCards/${Id}/Sale`, null, { responseType: 'blob' });
    },

    ForzePackage(Id) {
        return axios.post(`api/admin/VoucherCards/${Id}/Freeze`, null);
    },

    UnfreezePackage(Id) {
        return axios.post(`api/admin/VoucherCards/${Id}/Unfreeze`, null);
    },

    DeletePackage(Id) {
        return axios.post(`api/admin/VoucherCards/${Id}/Delete`);
    },



    //Card
    GetCards() {
        return axios.get(`api/admin/VoucherCards/Cards/Get`);
    },

    GetCardInfoBySerialNumber(SerialNumber) {
        return axios.get(`api/admin/VoucherCards/Cards/GetCardInfoBySerialNumber?SerialNumber=${SerialNumber}`);
    },

    GetCardInfoByVoucherNumber(VoucherNumber) {
        return axios.get(`api/admin/VoucherCards/Cards/GetCardInfoByVoucherNumber?SerialNumber=${VoucherNumber}`);
    },


    //TryAttemp
    GetVoucherCardsTryAttemp(pageNo, pageSize, Search) {
        return axios.get(`api/admin/VoucherCards/TryAttemp/Get?pageNo=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },



    //Chart
    GetVoucherCardsChart() {
        return axios.get(`api/admin/VoucherCards/Chart/Get`);
    },






    //Distributors
    GetDistributors(pageNo, pageSize, Search) {
        return axios.get(`api/admin/VoucherCards/Distributors/Get?pageNo=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllDistributors() {
        return axios.get(`api/admin/VoucherCards/Distributors/GetAll`);
    },

    AddDistributors(bodyObject) {
        return axios.post('api/admin/VoucherCards/Distributors/Add', bodyObject);
    },

    EditDistributors(bodyObject) {
        return axios.post('api/admin/VoucherCards/Distributors/Edit', bodyObject);
    },

    ResetPasswordDistributors(Id) {
        return axios.post(`api/admin/VoucherCards/${Id}/Distributors/ResetPassword`);
    },

    ChangeStatusDistributors(Id) {
        return axios.post(`api/admin/VoucherCards/${Id}/Distributors/ChangeStatus`);
    },

    DeleteDistributors(Id) {
        return axios.post(`api/admin/VoucherCards/${Id}/Distributors/Delete`);
    },




    ActivePackgeDistributors(bodyObject) {
        return axios.post('api/admin/VoucherCards/Distributors/ActivePackge', bodyObject);
    },

    GetDistributorsPackages(pageNo, pageSize) {
        return axios.get(`api/admin/VoucherCards/Distributors/Packages/Get?pageNo=${pageNo}&pagesize=${pageSize}`);
    },

    // ********************************| End Of VoucherCards |********************************












    // ********************************| Users |********************************
    // schoolsId / schoolStaffOnly back the school filter and the school-only band on
    // /SchoolsUsers. Both are optional so every existing caller keeps its behaviour.
    GetUsers(pageNo, pageSize, Search, schoolsId, schoolStaffOnly) {
        let url = `api/admin/Users/Get?pageNo=${pageNo}&pagesize=${pageSize}&Search=${Search}`;
        if (schoolsId !== null && schoolsId !== undefined && schoolsId !== '') url += `&schoolsId=${schoolsId}`;
        if (schoolStaffOnly) url += `&schoolStaffOnly=true`;
        return axios.get(url);
    },

    GetSuspendedUsers(pageNo, pageSize, Search, Status) {
        let url = `api/admin/Users/GetSuspended?pageNo=${pageNo}&pagesize=${pageSize}&Search=${Search}`;
        if (Status !== null && Status !== undefined && Status !== '') {
            url += `&Status=${Status}`;
        }
        return axios.get(url);
    },

    GetUserById(Id) {
        return axios.get(`api/admin/Users/${Id}`);
    },

    GetUsersTransactions(pageNoT, pageSizeT, Id) {
        return axios.get(`api/admin/Users/GetTransactions?pageNo=${pageNoT}&pagesize=${pageSizeT}&Id=${Id}`);
    },

    GetAllUsers() {
        return axios.get(`api/admin/Users/GetAll`);
    },

    AddUsers(bodyObject) {
        return axios.post('api/admin/Users/Add', bodyObject);
    },

    EditUsers(bodyObject) {
        return axios.post('api/admin/Users/Edit', bodyObject);
    },

    ResetPasswordUsers(Id) {
        return axios.post(`api/admin/Users/${Id}/ResetPassword`);
    },

    ChangeStatusUsers(Id) {
        return axios.post(`api/admin/Users/${Id}/ChangeStatus`);
    },

    DeleteUsers(Id) {
        return axios.post(`api/admin/Users/${Id}/Delete`);
    },

    SuspendUser(bodyObject) {
        return axios.post(`api/admin/Users/Suspend`, bodyObject);
    },

    GetUserSuspendInfo(Id) {
        return axios.get(`api/admin/Users/${Id}/SuspendInfo`);
    },

    CancelSuspendUser(Id) {
        return axios.post(`api/admin/Users/${Id}/CancelSuspend`);
    },

    GetUserDevices(Id) {
        return axios.get(`api/admin/Users/${Id}/Devices`);
    },

    GetUserLocations(Id, pageNo, pageSize) {
        return axios.get(`api/admin/Users/${Id}/Locations?pageno=${pageNo}&pagesize=${pageSize}`);
    },

    AddUserLocation(bodyObject) {
        return axios.post(`api/admin/Users/Locations/Add`, bodyObject);
    },

    EditUserLocation(bodyObject) {
        return axios.post(`api/admin/Users/Locations/Edit`, bodyObject);
    },

    DeleteUserLocation(Id) {
        return axios.post(`api/admin/Users/Locations/${Id}/Delete`);
    },

    // Passengers Locations — uses Users endpoints
    AddPassengerLocation(bodyObject) {
        return axios.post(`api/admin/Users/Locations/Add`, bodyObject);
    },

    EditPassengerLocation(bodyObject) {
        return axios.post(`api/admin/Users/Locations/Edit`, bodyObject);
    },

    DeletePassengerLocation(Id) {
        return axios.post(`api/admin/Users/Locations/${Id}/Delete`);
    },

    SendNotification(bodyObject) {
        return axios.post(`api/admin/Users/Notifications/Send`, bodyObject);
    },


    //USerProfile 
    ChangeProfilePicture(bodyObject) {
        return axios.post('api/admin/Users/Profile/ChangePicture', bodyObject);
    },

    ChangeProfileInfo(bodyObject) {
        return axios.post('api/admin/Users/Profile/ChangeInfo', bodyObject);
    },

    ChangeProfilePassword(bodyObject) {
        return axios.post('api/admin/Users/Profile/ChangePassword', bodyObject);
    },

    ChangeProfileAppPicture(bodyObject) {
        return axios.post('api/admin/Users/Profile/App/ChangePicture', bodyObject);
    },





    //Financials
    PayUsersFinancials(bodyObject) {
        return axios.post(`api/admin/Users/Financials/Pay`, bodyObject);
    },

    GetUsersFinancials(Id) {
        return axios.get(`api/admin/Users/Financials/Get?Id=${Id}`);
    },

    DeleteUsersFinancials(Id) {
        return axios.post(`api/admin/Users/${Id}/Financials/Delete`);
    },


    // ********************************| End Of Users |********************************




    // ********************************| Passengers |********************************

    // Passengers
    GetPassengers(pageNo, pageSize, Search, Type, SchoolsId, status) {
        return axios.get(`api/admin/Passengers/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}&type=${Type}&schoolsId=${SchoolsId}&status=${status}`);
    },

    GetAllPassengers() {
        return axios.get(`api/admin/Passengers/GetAll`);
    },

    GetPassengerById(Id) {
        return axios.get(`api/admin/Passengers/${Id}`);
    },

    AddPassengers(bodyObject) {
        return axios.post(`api/admin/Passengers/Add`, bodyObject);
    },

    EditPassengers(bodyObject) {
        return axios.post(`api/admin/Passengers/Edit`, bodyObject);
    },

    DeletePassengers(Id) {
        return axios.post(`api/admin/Passengers/Delete/${Id}`);
    },
    SuspendPassengers(bodyObject) {
      
        return axios.post(`api/admin/Passengers/Suspend`, bodyObject);
    },
    CancelSuspendPassengers(Id) {
        return axios.post(`api/admin/Passengers/CancelSuspend/${Id}`);
    },
    // ********************************| End Of Passengers |********************************




    // ********************************| Drivers |********************************

    // Drivers
    GetSuspended(pageNo, pageSize, Search, schoolId) {
        let url = `api/admin/Drivers/GetSuspended?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`;
        if (schoolId) url += `&schoolId=${schoolId}`;
        return axios.get(url);
    },


    GetDrivers(pageNo, pageSize, Search, DriverStatus, schoolId) {
        let url = `api/admin/Drivers/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}&driverStatus=${DriverStatus}`;
        if (schoolId) url += `&schoolId=${schoolId}`;
        return axios.get(url);
    },

    GetAllDrivers(hasCamera) {
        const q = hasCamera ? '?hasCamera=true' : '';
        return axios.get(`api/admin/Drivers/GetAll${q}`);
    },

    SearchDriverByPhone(phone) {
        return axios.get(`api/admin/Drivers/SearchByPhone?phone=${encodeURIComponent(phone || '')}`);
    },

    GetDriverById(Id) {
        return axios.get(`api/admin/Drivers/${Id}`);
    },

    AddDrivers(bodyObject) {
        return axios.post(`api/admin/Drivers/Add`, bodyObject);
    },

    EditDrivers(bodyObject) {
        return axios.post(`api/admin/Drivers/Edit`, bodyObject);
    },

    DeleteDrivers(Id) {
        return axios.post(`api/admin/Drivers/Delete/${Id}`);
    },

    // Audit P1 #8: unlink a driver from a school (driver↔school link row).
    RemoveDriverFromSchool(driverId, schoolId) {
        return axios.delete(`api/admin/Drivers/${driverId}/Schools/${schoolId}`);
    },

    ApproveDriver(Id) {
        return axios.post(`api/admin/Drivers/Approve/${Id}`);
    },

    // السبب يُخزَّن في Drivers.RejectReason ويُعرض للسائق في تطبيقه، فلا تُرسل
    // الطلب بدونه — كان يُرسل فارغاً فيُرفض السائق بلا تفسير يستطيع أحد قراءته.
    RejectDriver(Id, Reason) {
        return axios.post(`api/admin/Drivers/Reject/${Id}`, { Reason: Reason || '' });
    },

    ChangeActiveDriver(Id) {
        return axios.post(`api/admin/Drivers/${Id}/ChangeActive`);
    },

    // ---- Driver subscriptions (owner step trip-regular-5) ----
    // Lives on the DRIVERS page on purpose: /SubscriptionsDashboard and
    // /FinancialSubscriptions are read-only reports and /SubscriptionsTypes edits
    // PLANS, so none of them could ever end a driver's membership.
    GetDriverSubscriptions(Id) {
        return axios.get(`api/admin/Drivers/${Id}/Subscriptions`);
    },

    // bodyObject: { Reason (إلزامي), SubscriptionId (اختياري) }
    EndDriverSubscription(DriverId, bodyObject) {
        return axios.post(`api/admin/Drivers/${DriverId}/Subscription/End`, bodyObject);
    },



    CancelSuspendDriver(Id) {
        return axios.post(`api/admin/Drivers/CancelSuspend/${Id}`);
    },

    // Driver Vehicles
    GetDriverVehicles(Id) {
    
        return axios.get(`api/admin/Drivers/${Id}/Vehicles`);
    },
   
    AddDriverVehicle(bodyObject) {
        return axios.post(`api/admin/Drivers/Vehicles/Add`, bodyObject);
    },

    EditDriverVehicle(bodyObject) {
        return axios.post(`api/admin/Drivers/Vehicles/Edit`, bodyObject);
    },

    DeleteDriverVehicle(VehicleId) {
        return axios.post(`api/admin/Drivers/Vehicles/Delete/${VehicleId}`);
    },

    ApproveDriverVehicle(VehicleId) {
        return axios.post(`api/admin/Drivers/Vehicles/Approve/${VehicleId}`);
    },

    RejectDriverVehicle(VehicleId) {
        return axios.post(`api/admin/Drivers/Vehicles/Reject/${VehicleId}`);
    },

    SetPrimaryVehicle(id) {


        return axios.post(`/api/admin/Drivers/Vehicles/SetPrimary/${id}`);
    }
    ,
    AddVehicle(bodyObject) {
        return axios.post(`api/admin/Vehicles/Add`, bodyObject);
    },

    EditVehicle(bodyObject) {
        return axios.post(`api/admin/Vehicles/Edit`, bodyObject);
    },

    SuspendVehicle(id, reason = "") {
        const bodyObject = { reason: (reason || "").trim() };
        return axios.post(`api/admin/Vehicles/Suspend/${id}`, bodyObject);
    },
    CancelSuspendVehicle(Id) {
        return axios.post(`api/admin/Vehicles/CancelSuspend/${Id}`);
    },
    DeleteVehicle(VehicleId) {
        return axios.post(`api/admin/Vehicles/Delete/${VehicleId}`);
    },


    GetVehicleTypes() {
        
        return axios.get(`api/admin/Drivers/VehicleTypes`);
    },
    // Driver Trips
    GetDriverTrips(Id, pageNo, pageSize) {
        return axios.get(`api/admin/Drivers/${Id}/Trips?pageno=${pageNo}&pagesize=${pageSize}`);
    },

    // Driver Wallet
    GetDriverWalletTransactions(Id, pageNo, pageSize) {
        return axios.get(`api/admin/Drivers/${Id}/WalletTransactions?pageno=${pageNo}&pagesize=${pageSize}`);
    },

    ChargeDriverWallet(bodyObject) {
        return axios.post(`api/admin/Drivers/ChargeWallet`, bodyObject);
    },

    GetDriverWalletTracker(Id, pageNo, pageSize) {
        return axios.get(`api/admin/Drivers/${Id}/WalletTracker?pageno=${pageNo}&pagesize=${pageSize}`);
    },

    // Driver Ratings
    GetDriverRatings(Id, pageNo, pageSize) {
        return axios.get(`api/admin/Drivers/${Id}/Ratings?pageno=${pageNo}&pagesize=${pageSize}`);
    },

    GetAllDriverRatings(pageNo, pageSize, search) {
        return axios.get(`api/admin/Drivers/Ratings/GetAll?pageno=${pageNo}&pagesize=${pageSize}&search=${search || ''}`);
    },

    // Driver Financials
    GetDriverFinancials(Id, pageNo, pageSize) {
        return axios.get(`api/admin/Drivers/${Id}/Financials?pageno=${pageNo}&pagesize=${pageSize}`);
    },

    // ********************************| End Of Drivers |********************************




    // ********************************| Schools |********************************

    // Schools
    GetSchools(pageNo, pageSize, Search, LocationsId, schoolUserId) {
        let url = `api/admin/Schools/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}&locationsId=${LocationsId}`;
        if (schoolUserId) url += `&schoolUserId=${schoolUserId}`;
        return axios.get(url);
    },

    GetMySchool() {
        return axios.get(`api/admin/Schools/MySchool`);
    },

    // schoolUserId is the OWNER'S USER id and is meaningful only for a super-admin asking
    // about someone else's school — a school owner/employee is scoped server-side to their
    // own school. Omit the param entirely when falsy; it used to emit
    // "?schoolUserId=undefined" on every call that passed nothing.
    GetAllSchools(schoolUserId) {
        const base = `api/admin/Schools/GetAll`;
        return axios.get(schoolUserId ? `${base}?schoolUserId=${schoolUserId}` : base);
    },

    GetSchoolById(Id) {
        return axios.get(`api/admin/Schools/${Id}`);
    },

    AddSchools(bodyObject) {
        return axios.post(`api/admin/Schools/Add`, bodyObject);
    },

    EditSchools(bodyObject) {
        return axios.post(`api/admin/Schools/Edit`, bodyObject);
    },

    DeleteSchools(Id) {
        return axios.post(`api/admin/Schools/Delete/${Id}`);
    },

    SuspendSchools(Id, bodyObject) {
        return axios.post(`api/admin/Schools/Suspend/${Id}`, bodyObject);
    },

    CancelSuspendSchools(Id) {
        return axios.post(`api/admin/Schools/CancelSuspend/${Id}`);
    },

    // School Users
    GetSchoolUsers(Id) {
        return axios.get(`api/admin/Schools/${Id}/Users`);
    },

    AddSchoolUser(bodyObject) {
        return axios.post(`api/admin/Schools/Users/Add`, bodyObject);
    },

    EditSchoolUser(bodyObject) {
        return axios.post(`api/admin/Schools/Users/Edit`, bodyObject);
    },

    DeleteSchoolUser(SchoolsUserId) {
        return axios.post(`api/admin/Schools/Users/${SchoolsUserId}/Delete`);
    },

    // School Subscriptions
    GetSchoolSubscriptions(Id) {
        return axios.get(`api/admin/Schools/${Id}/Subscriptions`);
    },
    AddSchoolSubscription(bodyObject) {
       
        return axios.post(`api/admin/Schools/Subscriptions/Add`, bodyObject);
    },
    DeleteSchoolSubscription(schoolId, subscriptionId) {
        return axios.post(`api/admin/Schools/${schoolId}/Subscriptions/${subscriptionId}/Delete`);
    },
    DropSchoolSubscription(bodyObject) {
        return axios.post(`api/admin/Schools/Subscriptions/Drop`, bodyObject);
    }, AddSubscriptionValue(bodyObject) {
     
        return axios.post(`api/admin/Schools/Subscriptions/AddAllValue`, bodyObject);
    },
    GetWallet(id) {
        return axios.get(`api/admin/Schools/Wallet/Get?id=${id}`);
    },
    ChargeWallet(bodyObject) {
        return axios.post(`api/admin/Schools/Wallet/Charge`, bodyObject);
    },


    // ********************************| End Of Schools |********************************




    // ********************************| Trips |********************************

    // Trips
    GetTrips(pageNo, pageSize, Search, Status, Levels, DateFrom, DateTo, TripType, PaymentMethodId) {
        // Search is free text typed by an operator ("عبدالله", "TRP-1/2") — it has to be
        // percent-encoded or a '&' or '#' in the box silently truncates the query string.
        let url = `api/admin/Trips/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${encodeURIComponent(Search || '')}&status=${Status}&dateFrom=${DateFrom}&dateTo=${DateTo}`;

        // Handle multiple levels - backend expects List<short>
        if (Levels) {
            if (typeof Levels === 'string' && Levels.includes(',')) {
                // Split comma-separated string and add each level as separate parameter
                const levelArray = Levels.split(',');
                levelArray.forEach(level => {
                    url += `&levels=${level.trim()}`;
                });
            } else {
                // Single level
                url += `&levels=${Levels}`;
            }
        }

        // Add Trip Type filter
        if (TripType) {
            url += `&tripType=${TripType}`;
        }

        // Payment method filter (Dictionaries/PaymentMethods)
        if (PaymentMethodId) {
            url += `&paymentMethodId=${PaymentMethodId}`;
        }

        return axios.get(url);
    },

    // School Trips - Dedicated Controller
    GetSchoolTrips(pageNo, pageSize, Search, Status, Levels, DateFrom, DateTo) {
        let url = `api/admin/SchoolTrips/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}&status=${Status}&dateFrom=${DateFrom}&dateTo=${DateTo}`;
        
        if (Levels) {
            if (typeof Levels === 'string' && Levels.includes(',')) {
                const levelArray = Levels.split(',');
                levelArray.forEach(level => {
                    url += `&levels=${level.trim()}`;
                });
            } else {
                url += `&levels=${Levels}`;
            }
        }
        
        return axios.get(url);
    },

    // Shared Trips - Dedicated Controller
    GetSharedTrips(pageNo, pageSize, Search, Status, Levels, DateFrom, DateTo) {
        let url = `api/admin/SharedTrips/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}&status=${Status}&dateFrom=${DateFrom}&dateTo=${DateTo}`;
        
        if (Levels) {
            if (typeof Levels === 'string' && Levels.includes(',')) {
                const levelArray = Levels.split(',');
                levelArray.forEach(level => {
                    url += `&levels=${level.trim()}`;
                });
            } else {
                url += `&levels=${Levels}`;
            }
        }
        
        return axios.get(url);
    },

    // Scheduled Trips - Dedicated Controller
    GetScheduledTrips(pageNo, pageSize, Search, Status, Levels, DateFrom, DateTo) {
        let url = `api/admin/ScheduledTrips/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}&status=${Status}&dateFrom=${DateFrom}&dateTo=${DateTo}`;
        
        if (Levels) {
            if (typeof Levels === 'string' && Levels.includes(',')) {
                const levelArray = Levels.split(',');
                levelArray.forEach(level => {
                    url += `&levels=${level.trim()}`;
                });
            } else {
                url += `&levels=${Levels}`;
            }
        }
        
        return axios.get(url);
    },

    GetTripById(Id) {
        return axios.get(`api/admin/Trips/${Id}`);
    },

    CancelTrip(Id) {
        return axios.post(`api/admin/Trips/${Id}/Cancel`);
    },

    GetTripCategories() {
        return axios.get(`api/admin/Trips/Categories`);
    },

    GetTripCategory(Id) {
        return axios.get(`api/admin/Trips/${Id}/Category`);
    },

    GetTripChats(Id) {
        return axios.get(`api/admin/Trips/${Id}/Chats`);
    },

    GetTripDriverCandidates(Id) {
        return axios.get(`api/admin/Trips/${Id}/DriverCandidates`);
    },

    GetTripLevels(Id) {
        return axios.get(`api/admin/Trips/${Id}/Levels`);
    },

    GetTripRatings(Id) {
        return axios.get(`api/admin/Trips/${Id}/Ratings`);
    },

    GetTripPassenger(Id) {
        return axios.get(`api/admin/Trips/${Id}/Passenger`);
    },

    AssignDriverToTrip(Id, bodyObject) {
        return axios.post(`api/admin/Trips/${Id}/AssignDriver`, bodyObject);
    },

    // Web P0 FIX: advance a trip's state from the admin dashboard.
    // newStatus: 3=Arrived, 4=Started, 5=Completed.
    SetTripState(Id, newStatus) {
        return axios.post(`api/admin/Trips/${Id}/SetState`, { NewStatus: newStatus });
    },

    // ********************************| End Of Trips |********************************




    // ====================================================================
    // Sprint A2 (Agent-A2 2026-05-20) — Frontend pages backing the
    // §2/§3/§4/§7/§11 system rules. Endpoints are read-only from the
    // Vue side: every URL maps to an existing .NET controller route under
    // Rafiq/Management/Controllers/ and is wired here so .vue files
    // stay declarative (no axios calls inline).
    // ====================================================================

    // ----- Pricing (PR-11 / §2) — api/admin/Pricing -----
    GetPricingConfiguration() {
        return axios.get(`api/admin/Pricing/Configuration`);
    },
    UpdatePricingConfiguration(categoryId, body) {
        return axios.put(`api/admin/Pricing/Configuration/${categoryId}`, body);
    },
    GetActiveSurges() {
        return axios.get(`api/admin/Pricing/Surge/Active`);
    },
    GetPricingTimeWindows(categoryId) {
        return axios.get(`api/admin/Pricing/TimeWindows/${categoryId}`);
    },
    UpdatePricingTimeWindows(categoryId, body) {
        return axios.put(`api/admin/Pricing/TimeWindows/${categoryId}`, body);
    },
    // PR-12 — Pricing change log viewer.
    // NOTE: GET endpoint NOT present in PricingController.cs as of 2026-05-20.
    // The page falls back to a "missing endpoint" notice; backend (Agent A1)
    // should add `GET api/admin/Pricing/ChangeLog?from&to&userId&page&size`.
    GetPricingChangeLog(pageNo, pageSize, From, To, UserId) {
        return axios.get(
            `api/admin/Pricing/ChangeLog?pageno=${pageNo}&pagesize=${pageSize}` +
            `&from=${From || ''}&to=${To || ''}&userId=${UserId || ''}`
        );
    },

    // ----- SOS (SOS-12 / §4) — api/admin/Sos -----
    GetSosActive() {
        return axios.get(`api/admin/Sos/Active`);
    },
    GetSosHistory(page, size, status, from, to) {
        return axios.get(
            `api/admin/Sos/History?page=${page || 1}&size=${size || 20}` +
            `&status=${status || ''}&from=${from || ''}&to=${to || ''}`
        );
    },
    AssignSos(id, dispatcherUserId) {
        return axios.post(`api/admin/Sos/${id}/Assign`, { DispatcherUserId: dispatcherUserId });
    },
    // H13 (audit 2026-06-02): body MUST carry the canonical SosEvent.Status as
    // { NewStatus: 3 } to resolve or { NewStatus: 4 } for a false alarm (NOT the
    // old 5/6 which never matched the DB). ResolutionNote is optional.
    ResolveSos(id, body) {
        return axios.post(`api/admin/Sos/${id}/Resolve`, body);
    },
    GetSosTrail(id) {
        return axios.get(`api/admin/Sos/${id}/Trail`);
    },
    GetSosLiveContext(id) {
        return axios.get(`api/admin/Sos/${id}/LiveContext`);
    },

    // ----- Trusted Contacts (SOS-13 / UI-09)
    // No dedicated admin endpoint discovered in the Controllers folder as
    // of 2026-05-20 — Domain has UsersTrustedContacts but the read-only
    // admin route is missing. Page surfaces the gap to the operator.
    GetUserTrustedContacts(userId) {
        return axios.get(`api/admin/Users/${userId}/TrustedContacts`);
    },

    // ----- SMS Simulator (Agent-3 2026-05-20) — api/admin/sms-simulator
    // Shows the last N rows from SmsSimulatorMessages so QA can read OTPs
    // from the admin dashboard while Sms:Mode == "Simulator".
    //
    // 2026-05-23 (Task 16.5): GetSmsSimulator(opts) — opts supports
    //   { phone, tripId, studentPassengerId, sinceUtc, take }. Built with
    //   URLSearchParams so empty values are omitted from the URL.
    GetSmsSimulator(opts) {
        const params = new URLSearchParams();
        const o = opts || {};
        if (o.phone) params.set('phone', o.phone);
        if (o.tripId) params.set('tripId', o.tripId);
        if (o.studentPassengerId) params.set('studentPassengerId', o.studentPassengerId);
        if (o.sinceUtc) params.set('sinceUtc', o.sinceUtc);
        params.set('take', o.take || 200);
        return axios.get(`api/admin/sms-simulator?${params.toString()}`);
    },

    // Back-compat shim kept for any caller still using the old positional API.
    // (Dropped the never-used `channel` param — GetSmsSimulator ignores it; it
    //  was a pre-existing no-unused-vars build break. Extra positional args from
    //  old callers are harmlessly ignored by JS.)
    GetSmsSimulatorMessages(take, phone) {
        return this.GetSmsSimulator({ take: take || 100, phone });
    },

    // ----- Admin Notifications Broadcast (NOT-11) — api/admin/Notifications -----
    BroadcastAdminNotification(body) {
        return axios.post(`api/admin/Notifications/Broadcast`, body);
    },

    // ----- Reports queue (NOT-13 / §4.6) — api/admin/Reports
    // These are user-submitted incident reports (resolve/assign workflow),
    // mirrors AdminNotificationsController/ReportsController in backend.
    GetReportsQueue(page, size, status) {
        return axios.get(
            `api/admin/Reports?page=${page || 1}&size=${size || 20}&status=${status || ''}`
        );
    },
    GetReportDetail(id) {
        return axios.get(`api/admin/Reports/${id}`);
    },
    AssignReport(id, adminUserId) {
        return axios.post(`api/admin/Reports/${id}/Assign`, { AdminUserId: adminUserId });
    },
    ReplyReport(id, message, isInternal) {
        return axios.post(`api/admin/Reports/${id}/Reply`, { Message: message, IsInternal: !!isInternal });
    },
    ResolveReport(id, resolutionNote, newStatus) {
        return axios.post(`api/admin/Reports/${id}/Resolve`, { ResolutionNote: resolutionNote, NewStatus: newStatus });
    },
    EscalateReport(id) {
        return axios.post(`api/admin/Reports/${id}/Escalate`);
    },
    GetReportsStats() {
        return axios.get(`api/admin/Reports/Stats`);
    },

    // ----- Commission Rules (Audit P1 #10) — api/admin/CommissionRules
    // Super-admin only on the server; the route + menu are also gated to
    // userType==1. Maps 1:1 to CommissionRulesController CRUD.
    GetCommissionRules() {
        return axios.get(`api/admin/CommissionRules`);
    },
    CreateCommissionRule(bodyObject) {
        return axios.post(`api/admin/CommissionRules`, bodyObject);
    },
    UpdateCommissionRule(id, bodyObject) {
        return axios.put(`api/admin/CommissionRules/${id}`, bodyObject);
    },
    DeleteCommissionRule(id) {
        return axios.delete(`api/admin/CommissionRules/${id}`);
    },
    TestCommissionRule(categoryId, driverType, tier) {
        const q = [
            categoryId != null ? `categoryId=${categoryId}` : '',
            driverType != null ? `driverType=${driverType}` : '',
            tier != null ? `tier=${tier}` : ''
        ].filter(Boolean).join('&');
        return axios.get(`api/admin/CommissionRules/Test${q ? '?' + q : ''}`);
    },

    // ----- Cancellation Policies (CN-16 / UI-10 / §3) — api/admin/CancellationPolicies -----
    GetCancellationPolicies() {
        return axios.get(`api/admin/CancellationPolicies`);
    },
    CreateCancellationPolicy(body) {
        return axios.post(`api/admin/CancellationPolicies`, body);
    },
    UpdateCancellationPolicy(id, body) {
        return axios.put(`api/admin/CancellationPolicies/${id}`, body);
    },
    DeleteCancellationPolicy(id) {
        return axios.delete(`api/admin/CancellationPolicies/${id}`);
    },
    TestCancellationPolicy(actorType, atLevel, minutesBeforePickup) {
        return axios.get(
            `api/admin/CancellationPolicies/Test?actorType=${actorType}` +
            `&atLevel=${atLevel || ''}&minutesBeforePickup=${minutesBeforePickup}`
        );
    },

    // ----- Withdrawal moderation (fix ADM-001 / §7.3) -----
    // The live mobile app records a driver payout as a Financial row ('طلب سحب')
    // via Drivers/RequestPayout (balance held at request time). Moderate it with
    // the COHERENT admin endpoints keyed by that Financial.Id; reject refunds the
    // held funds. (The old api/admin/Financial/Withdraw/{id}/* path looked up
    // WalletTransactions ProcessType=4, which the mobile flow never writes.)
    ApproveWithdraw(financialId, note) {
        return axios.post(`api/admin/Drivers/Payouts/${financialId}/Approve`, { Note: note || '' });
    },
    RejectWithdraw(financialId, reason) {
        return axios.post(`api/admin/Drivers/Payouts/${financialId}/Reject`, { Note: reason || '' });
    },

    // ----- Manual wallet transaction (WAL-18 / UI-18)
    // NOTE: No `/api/admin/Wallet/ManualTransaction` endpoint exists yet
    // in FinancialController.cs as of 2026-05-20. Page form will surface
    // a clear error from backend until Agent A1 lands it.
    CreateManualWalletTransaction(body) {
        return axios.post(`api/admin/Financial/Wallet/ManualTransaction`, body);
    },

    // ----- School invoices (SCH-16 / UI-12)
    // NOTE: No SchoolInvoices endpoint yet — page documents the gap and
    // displays SchoolSubscriptions data as the closest available source.
    GetSchoolInvoices(schoolId, From, To, page, size) {
        return axios.get(
            `api/admin/Schools/${schoolId}/Invoices?from=${From || ''}&to=${To || ''}` +
            `&page=${page || 1}&size=${size || 20}`
        );
    },
    // توليد/تحديث فاتورة الشهر الحالي لمدرسة (super-admin) — SchoolsController.RefreshSchoolBilling.
    RefreshSchoolInvoice(schoolId) {
        return axios.post(`api/admin/Schools/${schoolId}/Subscriptions/Refresh`);
    },

    // ----- School daily attendance (SCH-13) — uses SchoolTrips/Absences -----
    GetSchoolAttendance(schoolId, From, To) {
        return axios.get(
            `api/admin/SchoolTrips/Absences?schoolId=${schoolId || ''}` +
            `&from=${From || ''}&to=${To || ''}`
        );
    },

    // ===== Dashboard cleanup 2026-06-02 — real pages replacing the dead Home/* clones =====
    // Revenue/sales dashboard (المبيعات) — wired to the existing RevenueDashboard.vue at /Sales.
    GetRevenueReport(dateFrom, dateTo) {
        return axios.get(`api/admin/Reports/Revenue?dateFrom=${dateFrom || ''}&dateTo=${dateTo || ''}`);
    },
    // Wallets overview (المحافظ الإلكترونية) — per-user balances + total float (NOT a transaction log).
    GetWalletsOverview(pageNo, pageSize, search) {
        return axios.get(`api/admin/Financial/GetWalletsOverview?pageNo=${pageNo || 1}&pageSize=${pageSize || 10}&search=${search || ''}`);
    },
    // Subscriptions overview (نظرة عامة - الاشتراكات) — KPIs: active / MRR / expiring / by-plan.
    GetSubscriptionsDashboard() {
        return axios.get(`api/admin/Financial/GetSubscriptionsDashboard`);
    },
    // Voucher-cards list (قائمة الكروت) — paginated full list.
    GetCardsList(pageNo, pageSize, Search) {
        return axios.get(`api/admin/VoucherCards/Cards/List?pageNo=${pageNo || 1}&pageSize=${pageSize || 10}&Search=${Search || ''}`);
    },
    // Voucher-card charging operations (شحن الكروت).
    GetVoucherCardsCharging(pageNo, pageSize, Search, from, to) {
        return axios.get(`api/admin/VoucherCards/Charging/Get?pageNo=${pageNo || 1}&pageSize=${pageSize || 10}&Search=${Search || ''}&from=${from || ''}&to=${to || ''}`);
    },

    // ****************************| Contract trips — طلبات التعاقد |****************************
    // Super-admin only. Every list endpoint returns the standard { info, count, statistics }
    // envelope. Assignment endpoints may answer 409 with
    // { Code: 'ASSIGNMENT_CONFLICT', Reasons: [{ Code, Message, ConflictingLabel }] } —
    // callers must render EVERY reason, not just the first.

    GetContractRequests(pageNo, pageSize, Search, requestStatus, clientType) {
        return axios.get(`api/admin/ContractRequests/Get?pageno=${pageNo || 1}&pagesize=${pageSize || 10}`
            + `&Search=${Search || ''}&requestStatus=${requestStatus || ''}&clientType=${clientType || ''}`);
    },
    GetContractRequestById(Id) {
        return axios.get(`api/admin/ContractRequests/${Id}`);
    },
    StartContractRequestReview(Id) {
        return axios.post(`api/admin/ContractRequests/${Id}/StartReview`);
    },
    ContractRequestNeedsInfo(Id, bodyObject) {
        return axios.post(`api/admin/ContractRequests/${Id}/NeedsInfo`, bodyObject);
    },
    RejectContractRequest(Id, bodyObject) {
        return axios.post(`api/admin/ContractRequests/${Id}/Reject`, bodyObject);
    },
    // Factor-by-factor price breakdown used by the quote composer.
    GetContractPriceSuggestion(Id) {
        return axios.get(`api/admin/ContractRequests/${Id}/PriceSuggestion`);
    },
    AddContractQuote(Id, bodyObject) {
        return axios.post(`api/admin/ContractRequests/${Id}/Quotes`, bodyObject);
    },
    ApproveAndSendContractQuote(QuoteId) {
        return axios.post(`api/admin/ContractRequests/Quotes/${QuoteId}/ApproveAndSend`);
    },

    // ****************************| Contract trips — العقود |****************************
    GetContracts(pageNo, pageSize, Search, contractStatus, clientType) {
        return axios.get(`api/admin/Contracts/Get?pageno=${pageNo || 1}&pagesize=${pageSize || 10}`
            + `&Search=${Search || ''}&contractStatus=${contractStatus || ''}&clientType=${clientType || ''}`);
    },
    GetContractById(Id) {
        return axios.get(`api/admin/Contracts/${Id}`);
    },
    UpdateContractPolicies(Id, bodyObject) {
        return axios.put(`api/admin/Contracts/${Id}/Policies`, bodyObject);
    },
    ActivateContract(Id) {
        return axios.post(`api/admin/Contracts/${Id}/Activate`);
    },
    SuspendContract(Id, bodyObject) {
        return axios.post(`api/admin/Contracts/${Id}/Suspend`, bodyObject);
    },
    LiftContractSuspension(SuspensionId) {
        return axios.post(`api/admin/Contracts/Suspensions/${SuspensionId}/Lift`);
    },
    TerminateContract(Id, bodyObject) {
        return axios.post(`api/admin/Contracts/${Id}/Terminate`, bodyObject);
    },
    RenewContract(Id, bodyObject) {
        return axios.post(`api/admin/Contracts/${Id}/Renew`, bodyObject);
    },

    // ----- Groups / schedule slots / passengers / assignments -----
    GetContractGroups(Id) {
        return axios.get(`api/admin/Contracts/${Id}/Groups`);
    },
    AddContractGroup(Id, bodyObject) {
        return axios.post(`api/admin/Contracts/${Id}/Groups`, bodyObject);
    },
    EditContractGroup(GroupId, bodyObject) {
        return axios.put(`api/admin/Contracts/Groups/${GroupId}`, bodyObject);
    },
    AddContractGroupSlot(GroupId, bodyObject) {
        return axios.post(`api/admin/Contracts/Groups/${GroupId}/Slots`, bodyObject);
    },
    DeleteContractGroupSlot(SlotId) {
        return axios.delete(`api/admin/Contracts/Slots/${SlotId}`);
    },
    AddContractGroupPassenger(GroupId, bodyObject) {
        return axios.post(`api/admin/Contracts/Groups/${GroupId}/Passengers`, bodyObject);
    },
    DeleteContractGroupPassenger(PassengerId) {
        return axios.delete(`api/admin/Contracts/Passengers/${PassengerId}`);
    },
    AddContractGroupAssignment(GroupId, bodyObject) {
        return axios.post(`api/admin/Contracts/Groups/${GroupId}/Assignments`, bodyObject);
    },
    GetContractGroupAvailableDrivers(GroupId) {
        return axios.get(`api/admin/Contracts/Groups/${GroupId}/AvailableDrivers`);
    },
    AddContractGroupSubstitution(GroupId, bodyObject) {
        return axios.post(`api/admin/Contracts/Groups/${GroupId}/Substitutions`, bodyObject);
    },

    // ----- Amendments -----
    GetContractAmendments(Id) {
        return axios.get(`api/admin/Contracts/${Id}/Amendments`);
    },
    ApplyContractAmendment(AmendmentId) {
        return axios.post(`api/admin/Contracts/Amendments/${AmendmentId}/Apply`);
    },

    // ****************************| Contract trips — الشركات والموظفون |****************************
    GetContractCompanies(pageNo, pageSize, Search, status) {
        return axios.get(`api/admin/Companies/Get?pageno=${pageNo || 1}&pagesize=${pageSize || 10}`
            + `&Search=${Search || ''}&status=${status || ''}`);
    },
    GetContractCompanyById(Id) {
        return axios.get(`api/admin/Companies/${Id}`);
    },
    AddContractCompany(bodyObject) {
        return axios.post(`api/admin/Companies`, bodyObject);
    },
    EditContractCompany(Id, bodyObject) {
        return axios.put(`api/admin/Companies/${Id}`, bodyObject);
    },
    DeleteContractCompany(Id) {
        return axios.delete(`api/admin/Companies/${Id}`);
    },
    GetContractCompanyEmployees(Id) {
        return axios.get(`api/admin/Companies/${Id}/Employees`);
    },
    AddContractCompanyEmployee(Id, bodyObject) {
        return axios.post(`api/admin/Companies/${Id}/Employees`, bodyObject);
    },
    // Excel import — the sheet is parsed IN THE BROWSER and posted as a JSON array.
    ImportContractCompanyEmployees(Id, rows) {
        return axios.post(`api/admin/Companies/${Id}/Employees/Import`, rows);
    },
    GetContractCompanyCreditExposure(Id) {
        return axios.get(`api/admin/Companies/${Id}/CreditExposure`);
    },

    // ****************************| Contract trips — الفواتير |****************************
    GetContractInvoices(pageNo, pageSize, Search, invoiceStatus, contractId) {
        return axios.get(`api/admin/ContractInvoices/Get?pageno=${pageNo || 1}&pagesize=${pageSize || 10}`
            + `&Search=${Search || ''}&invoiceStatus=${invoiceStatus || ''}&contractId=${contractId || ''}`);
    },
    MarkContractInvoicePaid(Id, bodyObject) {
        return axios.post(`api/admin/ContractInvoices/${Id}/MarkPaid`, bodyObject);
    },
    CancelContractInvoice(Id, bodyObject) {
        return axios.post(`api/admin/ContractInvoices/${Id}/Cancel`, bodyObject);
    },
    AdjustContractInvoice(Id, bodyObject) {
        return axios.post(`api/admin/ContractInvoices/${Id}/Adjust`, bodyObject);
    },

    // ****************************| Contract trips — الرحلات |****************************
    // Inherits the general trips list, pinned server-side to TripType 6.
    GetContractTrips(pageNo, pageSize, Search, levels, dateFrom, dateTo, contractId) {
        return axios.get(`api/admin/ContractTrips/Get?pageno=${pageNo || 1}&pagesize=${pageSize || 10}`
            + `&Search=${Search || ''}&levels=${levels || ''}`
            + `&dateFrom=${dateFrom || ''}&dateTo=${dateTo || ''}&contractId=${contractId || ''}`);
    },
    // Today's board + escalations + ContractJobRun health (jobHealth.lastSuccessOn).
    GetContractTripsTodayBoard() {
        return axios.get(`api/admin/ContractTrips/TodayBoard`);
    },
    ReassignContractTrip(TripId, bodyObject) {
        return axios.post(`api/admin/ContractTrips/${TripId}/Reassign`, bodyObject);
    },
    FlagContractTrip(TripId, bodyObject) {
        return axios.post(`api/admin/ContractTrips/${TripId}/Flag`, bodyObject);
    },
    CancelContractTripDay(TripId, bodyObject) {
        return axios.post(`api/admin/ContractTrips/${TripId}/CancelDay`, bodyObject);
    },
    AddContractAdHocTrip(bodyObject) {
        return axios.post(`api/admin/ContractTrips/AdHocTrip`, bodyObject);
    },

    // 30-day plan grid (خطة 30 يومًا) — reuses the trips list over a date window.
    GetContractPlanning(dateFrom, dateTo, contractId) {
        return axios.get(`api/admin/ContractTrips/Get?pageno=1&pagesize=1000`
            + `&dateFrom=${dateFrom || ''}&dateTo=${dateTo || ''}&contractId=${contractId || ''}`);
    },

}